import { Component, OnInit } from '@angular/core';

import { NavService } from 'src/app/core/services';

@Component({
  templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  constructor(private navService: NavService) {
    this.navService.setNav([]);
  }

  ngOnInit(): void { }
}
